import ObjectModelBuilderModel from "../tracked/objectModelBuilderModel";
import ObjectModel from "../objectModel";
import {
  ILabelable,
  ISortable,
  ISelectable,
} from "~/interfaces/propertyInterfaces";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import Guid from "~/helpers/guid";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import TrackedModel from "~/models/tracked/trackedModel";
import ElementHandler from "~/services/elementHandler";
import SortableMixin from "~/mixins/sortableMixin";
import GloballySelected from "../../../formability/object_model_builder/store/modules/selected";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import {ObjectModelPropertyCapability} from "~/models/objectModelProperties/objectModelPropertyCapability";

export default class PropertySection extends SortableMixin(ObjectModelBuilderModel) implements ILabelable, ISortable, ISelectable {
  static repo: IRepo<PropertySection> = new Repo<PropertySection>('propertySections', PropertySection);
  rootModel: ObjectModel
  label_title: string

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create()); // TODO: dedup
    this.defineProperty('sort_order', 0) // TODO: dedup into Sortable
    this.defineProperty('label_title', '')
  }

  // TODO: dedup
  initialize(root: ObjectModel, parent: ObjectModel, propertyType: number, json: object = {}): this {
    this.rootModel = root;
    this.parent = parent;
    this.loadFromJson(json);
    return this;
  }

  // required.
  get rootName() { return 'property_sections' }
  get displayName(): string { return ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.Section); }
  get icon(): string { return ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.Section); }

  get properties(): Array<ObjectModelProperty> {
    return this.parent?.objectModelPropertiesArray.filter((p) => {
      return p.property_section_client_id === this.client_id
    }) ?? [];
  }

  get permissionEditableProperties(): Array<ObjectModelProperty> {
    return this.parent?.objectModelPropertiesArray.filter((p) => {
      return p.property_section_client_id === this.client_id && p.can(ObjectModelPropertyCapability.permissionEditable);
    }) ?? [];
  }

  get isPermissionEditable(): boolean {
    return this.properties.some(property => property.can(ObjectModelPropertyCapability.permissionEditable));
  }

  get defaultLabelTitle(): string {
    return this.label_title || 'unnamed section';
  }

  sortableArray(prop: string) {
    if (prop === 'object_model_properties') {
      return this.properties
    } else {
      return this.propObjectToArray(prop)
    }
  }

  get sortableParent(): ObjectModel {
    return this.parent
  }

  get sortableHandler(): ElementHandler {
    return this.parent.propertySectionHandler
  }

  get selector(): typeof GloballySelected['propertySection'] {
    return GloballySelected.propertySection;
  }

  // TODO: consider adding to ISelectable
  get isSelected(): boolean {
    return this.selector.is(this);
  }

  get isSelectable(): boolean {
    return true
  }

  select(): void {
    if (this.isSelectable) {
      GloballySelected.objectModelProperty.deselect()
      this.selector.set(this);
    }
  }

  deselect(): void {
    this.selector.deselectIf(this);
  }

  get canDestroy(): boolean {
    return this.properties.length === 0
  }

  destroy(): void {
    if (this.canDestroy) {
      super.destroy()
    }
  }

  get labelTitleDisplay(): string {
    return this.label_title || 'Untitled Section';
  }
}
